import { Heading, Paragraph } from '@zillow/constellation';
import type { Answers } from '../../../../../graphql/queries';
import { getAnswersForFields } from '../../../../../utils/overview/overview-display';
import { FIELD_IDS } from '../../../../../constants/wizard';
import { pluralize } from '../../../../../utils/formatters';

interface Props {
  answers: Answers;
}

const fieldsInStep = [
  FIELD_IDS.SMALL_DOGS,
  FIELD_IDS.LARGE_DOGS,
  FIELD_IDS.CATS,
  FIELD_IDS.PETS_OTHER,
  FIELD_IDS.PETS_DESCRIPTION,
];

export function PetsOverview({ answers }: Props) {
  const answersForFields = getAnswersForFields({ fieldIds: fieldsInStep, answers });

  const hasPets =
    answersForFields[FIELD_IDS.SMALL_DOGS] ||
    answersForFields[FIELD_IDS.LARGE_DOGS] ||
    answersForFields[FIELD_IDS.CATS] ||
    answersForFields[FIELD_IDS.PETS_OTHER];

  return (
    <>
      {hasPets ? (
        <>
          {!!answersForFields[FIELD_IDS.SMALL_DOGS] && (
            <Paragraph>{pluralize('small dog', answersForFields[FIELD_IDS.SMALL_DOGS] as number)}</Paragraph>
          )}
          {!!answersForFields[FIELD_IDS.LARGE_DOGS] && (
            <Paragraph>{pluralize('large dog', answersForFields[FIELD_IDS.LARGE_DOGS] as number)}</Paragraph>
          )}
          {!!answersForFields[FIELD_IDS.CATS] && (
            <Paragraph>{pluralize('cat', answersForFields[FIELD_IDS.CATS] as number)}</Paragraph>
          )}
          {!!answersForFields[FIELD_IDS.PETS_OTHER] && (
            <Paragraph>{pluralize('other pet', answersForFields[FIELD_IDS.PETS_OTHER] as number)}</Paragraph>
          )}
          {answersForFields[FIELD_IDS.PETS_DESCRIPTION] && (
            <>
              <Heading level={6} marginY="xs">
                Details
              </Heading>
              <Paragraph>{answersForFields[FIELD_IDS.PETS_DESCRIPTION]}</Paragraph>
            </>
          )}
        </>
      ) : (
        <Paragraph>None</Paragraph>
      )}
    </>
  );
}
